// extracted by mini-css-extract-plugin
module.exports = {"marginBottom":"Invitation-Invitation-marginBottom-debffb3a"};